<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'产品报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">

            <!--查询表单-->
            <div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="公司" prop="company" >
								<brselect
										ref="company"
										clearable category="FlSalesOrganization_agentnumber"
										:v="q.company"
										v-model="q.company">
								</brselect>
							</el-form-item>
							<el-form-item label="产品大类" prop="category" >
								<el-select v-model="q.category" placeholder="请选择">
									<el-option
											v-for="item in options1"
											:key="item.code"
											:label="item.name"
											:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="月份" class="nianboxs" v-if="check1">
								<el-date-picker
										v-model="q.month"
										:clearable="false"
										type="month"
										value-format="yyyy-MM"
										placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item  class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
							</el-form-item>
						</div>
					</el-form>
				</div>
				
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30" style="overflow-x: auto;">
                <el-table @selection-change="handleSelectionChange" :model="q"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :border="true"
                          :summary-method="getSummaries"
                          show-summary
						  max-height="530"
                >
					<el-table-column
					        type="selection"
					        width="50"
					        label="全选">
					</el-table-column>
					<el-table-column
					        type="index"
					        fixed
							width="40"
							label="#">
					</el-table-column>
                    <el-table-column
                            prop="company"
                            :show-overflow-tooltip="true"
                            label="公司"
                            width="80"
							fixed
                    >
                        <template slot-scope="scope">
                            {{scope.row.company|dictname('FlSalesOrganization_agentnumber')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="category"
                            :show-overflow-tooltip="true"
                            label="产品大类"
                            min-width="120"
							fixed
                    >
                        <template slot-scope="scope">
                            {{scope.row.category|dictname('product_level')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="月度返利预提" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="monthRebate"
                                :show-overflow-tooltip="true"
                                label="月度返利计算"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.monthRebate).toFixed(0)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="quarterRebate"
                                :show-overflow-tooltip="true"
                                label="季度返利预提"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.quarterRebate).toFixed(0)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="quarterRebateAll"
                                :show-overflow-tooltip="true"
                                label="季度累计预提"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.quarterRebateAll).toFixed(0)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="flyuti"
                                :show-overflow-tooltip="true"
                                label="返利预提"
								width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.flyuti).toFixed(0)}}</div>
                            </template>

                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="累计应兑未兑" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="lastWeidui"
                                    :show-overflow-tooltip="true"
                                    label="上期应兑未兑"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: right;">{{Number(scope.row.lastWeidui).toFixed(0)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="yidui"
                                    :show-overflow-tooltip="true"
                                    label="本期返利兑现"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: right;">{{Number(scope.row.yidui).toFixed(0)}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="sap"
                                    :show-overflow-tooltip="true"
                                    label="本期下发SAP"
                                    width="150"
                            >
                                <template slot-scope="scope">
                                    <div style="text-align: right;">{{Number(scope.row.sap).toFixed(0)}}</div>
                                </template>
                            </el-table-column>
                        <el-table-column
                                prop="count"
                                :show-overflow-tooltip="true"
                                label="累计应兑未兑"
                                width="150"

                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.count).toFixed(0)}}</div>
                            </template>
                        </el-table-column>
                        </el-table-column>

                </el-table>
			</div>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
							   @click="exportExcel" v-auth="'khlybb_daochu'">批量导出
					</el-button>

				</div>
				<div class="h-pagination2">
					<pagination :page="q" @query="query"/>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
	import big from 'big.js'

    export default {
        components: {},
        data() {
            return {
                check1:true,
                value2:'',
                showhistory:false,
                instid: '',
                taskid:'',
                options1:[],
                //查询属性
                page:{
                    contractBaseId:'',
                    pageSize:20,
                    pageNo:1
                },
                q: {
                    styles: '',
                    taskid:'',
                    rebateChainGroup:null,
                    agentNameLike:'',
                    agentCodeLike:'',
                    type:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    pageNo:1,
                    id:null, //
                    agentName:null, //
                    agentCode:null, //
                    area:null,
                    ymmb:null,
                    ymxe:null, //
                    ymly:null, //
                    xymb:null, //
                    xyxe:null,
                    xyly:null,
                    sjmb:null, //
                    sjxe:null, //
                    sjly:null, //
                    ctmb:null,
                    ctxe:null,
                    ctly:null, //
                    zmb:null, //
                    zxe:null, //
                    zly:null,



                },
                //表格
                multipleSelection: [],
                countlist:[],

                //table列表
                tableData: [],
                flag:0,
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.q = {
                styles: '',
                taskid:'',
                agentNameLike:'',
                agentCodeLike:'',
                pageSize: 10,
                pageNo: 1,
                total: 0,
                month: this.doHandleDate(),
                type:2,
            }
            this.queryb();
            this.query();

        },
        methods: {

            doHandleDate() {
                var myDate = new Date();
                var tYear = myDate.getFullYear();
                var tMonth = myDate.getMonth();

                var m = tMonth + 1;
                if (m.toString().length == 1) {
                    m = "0" + m;
                }
                return tYear +'-'+ m;
            },
            queryb() {
                ss.fanli.pagecpbbQuanxian(this.q).then(rd=>{
                    console.log(rd,"AAAABBBBBB");
                    this.options1 = rd.list;
                });

            },
            //重置
            qingkong(){
                this.qijianLike=null,
                // this.q.fljsstyle='2';
                // this.q.rebateChainGroup='zhj';
                //     this.q={
                //         pageSize: 10,
                //         pageNo: 1,
                //         total: 0,
                //     }
                    this.q = {
                        styles: '',
                        taskid:'',
                        agentNameLike:'',
                        agentCodeLike:'',
                        month: this.doHandleDate(),
                        pageSize: 10,
                        pageNo: 1,
                        total: 0,
                        rebateChainGroup:'zhj',
                        type:2,
                    }
                    this.query();
            },
            query() {
                // console.log(this.q,"/././././././")
                ss.fanli.chanPinTable(this.q).then(rd=>{
                    // console.log(rd,"BBBBBB");
                    this.q.total = rd.total;
                    var rds = rd.records;
                     this.tableData = rds;
                     // console.log(rd.records,"@@@@@@!!!!!!!!!")
                });
            },
            // getSummaries(param){
            //     const { columns, data } = param;
            //     const sums = [];
            //     columns.forEach((column, index) => {
            //         if (index === 0) {
            //             sums[index] = '总计';
            //             return;
            //         }
            //         const values = data.map(item => Number(item[column.property]));
            //         if (!values.every(value => isNaN(value))) {
            //             sums[index] = values.reduce((prev, curr) => {
            //                 const value = Number(curr);
            //                 if (!isNaN(value)) {
            //                     return (new big(prev).plus(curr)).toFixed(2);
            //                 } else {
            //                     return prev;
            //                 }
            //             }, 0);
            //             console.log((this.countlist[0].monthRebate).slice(0,(this.countlist[0].monthRebate).length-1),"/././.1213/.")
            //             sums[3] = Number(this.countlist[0].monthRebate).toFixed(2);
            //             sums[4] = Number(this.countlist[0].quarterRebate).toFixed(2);
            //             sums[5] = Number(this.countlist[0].quarterRebateAll).toFixed(2);
            //             sums[6] = Number(this.countlist[0].flyuti).toFixed(2);
            //             sums[7] = Number(this.countlist[0].lastWeidui).toFixed(2);
            //             sums[8] = Number(this.countlist[0].yidui).toFixed(2);
            //             sums[9] = Number(this.countlist[0].sap).toFixed(2);
            //             sums[10] = Number(this.countlist[0].count).toFixed(2);
            //         } else {
            //             sums[index] = 'N/A';
            //         }
            //     });
            //
            //     return sums;
            // },
            handleFilter() {
                // console.log("QQQQQ")
                this.query();
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //开票明细批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.category+","+this.q.month);
                });
                if (idlist.length != 0) {
                    // console.log(idlist);
                    updownfile.down("/api/swyl/v1/demo/flXsptCategory/downloadExcelIdDetail", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/flXsptCategory/downloadExcelEntity", this.q, "post");
                }

            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column,index)
                    if (index === 0) {
                        sums[index] = '总计';
                        // console.log(index+"@@@@@@")
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        // console.log(sums[2],"/./././")
                        
                        sums[4] = Number(sums[4]).toFixed(0);
                        sums[5] =Number(sums[5]).toFixed(0);
                        sums[6] = Number(sums[6]).toFixed(0);
                        sums[7] = Number(sums[7]).toFixed(0);
                        sums[8] = Number(sums[8]).toFixed(0);
                        sums[9] = Number(sums[9]).toFixed(0);
						sums[10] = Number(sums[10]).toFixed(0);
						sums[11] = Number(sums[11]).toFixed(0);
                    } else {
                        sums[1] = '';
                        sums[2] = '';
						sums[3] = '';
                    }
                });

                return sums;
            },

        }
    }
</script>
<style>
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	/*table一条合计行滚动条样式*/
	/* .el-table{
	    overflow: auto;
	}
	.el-table .el-table__body-wrapper,
	.el-table .el-table__header-wrapper,
	.el-table .el-table__footer-wrapper{
	    overflow: visible;
	}
	.el-table::after{
	    position:relative !important;
	} */
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>